import React, { useState } from "react";
import { Redirect } from "react-router-dom";
import Showdown from "showdown";
import ArticleService from "../services/ArticleService";

import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

import "../assets/style/article.css";

const ArticleContent = ({ id }) => {

	const articleService = new ArticleService();
	const converter = new Showdown.Converter();
	
	const [ article, setArticle ] = useState(undefined);
	const [ loading, setLoading ] = useState(true);
	
	
	if(loading) {
	
		(async () => {

			try {
				const articleResult = await articleService.fetchArticle(id);

				setArticle(articleResult);
				setLoading(false);
			}
			catch(error) {
				console.error(error);
			}
			
		})();

	}

	return (
		<>
			{ article && <>
				<h3 id="date">{article.date.toLocaleDateString()}</h3>	
				<div id="content" dangerouslySetInnerHTML={{__html: converter.makeHtml(article.content)}}></div>
			</>}
		</>
	)
}

const ArticleContainer = ({ id }) => (
	<section id="article-showcase">
		<ArticleContent id={id} />
	</section>
);

const ArticlePage = ({ match }) => (
	<>
		<Navbar />
			{ match.params.id ? <ArticleContainer id={match.params.id} /> : <Redirect to="/blog" /> }
		<Footer />
	</>
);

export default ArticlePage;